import { Row, Col } from 'antd';
import { styled } from 'styled-components';
import { CheckOutlined } from '@ant-design/icons';
import { ReactNode } from 'react';

import { ConsultButton } from './ConsultButton';

import img_customize_01 from '../assets/img_customize_01.png';
import img_customize_02 from '../assets/img_customize_02.png';
import img_customize_03 from '../assets/img_customize_03.png';
import img_customize_04 from '../assets/img_customize_04.png';
import img_plan_pet_1 from '../assets/img_plan_pet_1.png';
import img_plan_pet_2 from '../assets/img_plan_pet_2.png';
import img_plan_pet_3 from '../assets/img_plan_pet_3.png';
import img_plan_pet_4 from '../assets/img_plan_pet_4.png';
import ScrollAnimation from 'react-animate-on-scroll';

const SolutionWrapper = styled.div`
    padding: 120px 32px;
    position: relative;

    &>div {
        background-color: #ECF4FD;
        border-radius: 30px;
        padding: 60px 100px;
        position: relative;

        &:nth-child(2) {
            margin-top: 40px;
        }
    }

    @media screen and (max-width: 768px) {
        padding: 80px 20px;

        &>div {
            padding: 60px 20px;

            &:nth-child(2) {
                margin-top: 20px;
            }
        }
    }
`;

const Header = styled(Row)`
    color: #1385C8;
    font-size: 56px;
    font-weight: bold;
    line-height: 76px;
    width: 100%;
    justify-content: center;
    margin-bottom: 60px;

    @media screen and (max-width: 768px) {
        font-size: 36px;
        line-height: 48px;
        margin-bottom: 40px;
    }
`;

const Card = styled(ScrollAnimation)`
    background-color: #FFFFFF;
    border-radius: 16px;
    margin: 10px;
    display: flex;
    justify-content: center;
    padding: 32px 0px 16px;
    flex-grow: 1;

    &>div {
        padding: 32px 40px;
    }

    @media screen and (max-width: 768px) {
        padding: 16px 0px;

        &>div {
            padding: 24px;
        }
    }
`;

const CardHeader = styled.div`
    font-size: 28px;
    font-weight: bold;
    line-height: 40px;
    color: #101720;
    margin-bottom: 24px;
`;

const Price = styled.div`
    display: flex;
    align-items: center;
    font-size: 18px;
    font-weight: 500;
    line-height: 28px;
    color: #101720;
    margin-bottom: 20px;
`;

const Tag = styled.div<{ bgc?: string }>`
    background-color: ${({ bgc }) => bgc ?? '#5199E0'};
    padding:6px 12px;
    border-radius: 8px;
    font-size: 16px;
    font-weight: bold;
    line-height: 24px;
    color: #FFFFFF;
    margin-right: 12px;
    word-break: keep-all;
`;

const FeatureWrapper = styled.div`
    display: flex;
    align-items: start;
    font-size: 16px;
    line-height: 24px;
    color: #101720;
    margin-bottom: 8px;

    div {
        width: 20px;
        height: 20px;
        margin-right: 10px;
        border-radius: 20px;
        background-color: #45B9AE;
        display: flex;
        flex-shrink: 0;
        justify-content: center;
        align-items: center;

        &>* {
            font-size: 12px;
            color: #FFFFFF;
            font-weight: bold;
        }
    }
`;

const SubTitle = styled.div`
    color: #101720;
    font-size: 24px;
    font-weight: bold;
    line-height: 36px;
    margin-bottom: 60px;
    text-align: center;
`;

const CustomizeItem = styled(Col)`
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 18px;
    line-height: 28px;
    text-align: center;

    img {
        width: 100%;
        margin-bottom: 20px;
    }

    @media screen and (max-width: 768px) {
        &:nth-child(n+2) {
            margin-top: 40px;
        }
    }
`;

const CustomizeHeader = styled.div`
    color: #1385C8;
    font-size: 24px;
    font-weight: bold;
    line-height: 36px;
    margin-bottom: 20px;
    text-align: center;
`;

const Solution = () => {

    const FeatureItem: React.FC<{ children?: ReactNode }> = (props) => (
        <FeatureWrapper>
            <div><CheckOutlined/></div>
            {props.children}
        </FeatureWrapper>
    );

    return (
        <SolutionWrapper id='solution'>
            <div>
                <img
                    src={img_plan_pet_1}
                    alt='img_plan_pet_1'
                    style={{
                        position: 'absolute',
                        top: '-102px',
                        left: '120px',
                        width: '160px'
                    }}
                />
                <Header>企業方案</Header>
                <Row justify='center'>
                    <Col md={7} sm={24} xs={24} style={{ display: 'flex' }}>
                        <Card animateIn='fadeIn' animateOnce>
                            <div>
                                <CardHeader>AI 動作賽事</CardHeader>
                                <Price>
                                    <Tag>單次</Tag> $13,800
                                </Price>
                                <FeatureItem>35+ 種 AI 動作模型任選</FeatureItem>
                                <FeatureItem>企業專屬賽事管理後台</FeatureItem>
                                <FeatureItem>後台數據儀表板</FeatureItem>
                                <FeatureItem>一鍵產出 ESG 報告</FeatureItem>
                                <FeatureItem>自由搭配賽制<br/>（團體 / 個人、達成制、排名制）</FeatureItem>
                            </div>
                        </Card>
                    </Col>
                    <Col md={7} sm={24} xs={24} style={{ display: 'flex' }}>
                        <Card animateIn='fadeIn' animateOnce delay={200}>
                            <div>
                                <CardHeader>步行賽</CardHeader>
                                <Price>
                                    <Tag>單次</Tag> $13,800
                                </Price>
                                <FeatureItem>步數自動串聯雲端數據</FeatureItem>
                                <FeatureItem>即時掌握賽事狀況</FeatureItem>
                                <FeatureItem>即時顯示剩餘步數</FeatureItem>
                                <FeatureItem>防弊機制</FeatureItem>
                                <FeatureItem>後台管理運動數據</FeatureItem>
                                <FeatureItem>一鍵產出 ESG 報告</FeatureItem>
                                <FeatureItem>自由搭配賽制<br/>（團體 / 個人、達成制、排名制）</FeatureItem>
                            </div>
                        </Card>
                    </Col>
                    <Col md={7} sm={24} xs={24} style={{ display: 'flex' }}>
                        <Card animateIn='fadeIn' animateOnce delay={400} style={{ position: 'relative' }}>
                            <div style={{
                                position: 'absolute',
                                top: 0,
                                left: 'auto',
                                right: 'auto',
                                backgroundColor: '#F7CC3F',
                                borderRadius: '0 0 100px 100px',
                                fontSize: '16px',
                                fontWeight: 'bold',
                                lineHeight: '24px',
                                padding: '5px 60px'
                            }}>最優惠</div>
                            <div>
                                <CardHeader>AI 動作 + 步行賽</CardHeader>
                                <Price>
                                    <Tag bgc='#FA8290'>年訂閱</Tag>
                                    <span>以企業規模劃分級距<br/>享有多種優惠</span>
                                </Price>
                                <FeatureItem>所有 AI 動作賽事 功能</FeatureItem>
                                <FeatureItem>所有 步行賽 功能</FeatureItem>
                                <FeatureItem>二種賽事任選</FeatureItem>
                                <FeatureItem>不限使用次數</FeatureItem>
                            </div>
                        </Card>
                    </Col>
                </Row>
                <Row style={{ display: 'flex', justifyContent: 'center', marginTop: '60px' }}>
                    <ConsultButton />
                </Row>
                <Col md={24} sm={0} xs={0} style={{ position: 'absolute', bottom: '-40px', right: '100px' }}>
                    <img src={img_plan_pet_2} alt='img_plan_pet_2' style={{ width: '200px' }} />
                </Col>
            </div>
            <div>
                <Col md={24} sm={0} xs={0} style={{ position: 'absolute', top: '-50px', left: '150px' }}>
                    <img src={img_plan_pet_3} alt='img_plan_pet_3' style={{ width: '180px' }} />
                </Col>
                <Header>客製化套餐</Header>
                <SubTitle>可依您的需求選配報價</SubTitle>
                <Row justify='space-between' align='top'>
                    <CustomizeItem md={5} sm={24} xs={24}>
                        <ScrollAnimation animateIn='fadeIn' animateOnce>
                            <img src={img_customize_01} alt='img_customize_01' />
                            <CustomizeHeader>客製化精靈<br/>企業吉祥物</CustomizeHeader>
                            將公司既有吉祥物置入 APP 中，伴隨用戶運動養成，也可為您客製化。
                        </ScrollAnimation>
                    </CustomizeItem>
                    <CustomizeItem md={5} sm={24} xs={24}>
                        <ScrollAnimation animateIn='fadeIn' animateOnce delay={200}>
                            <img src={img_customize_02} alt='img_customize_02' />
                            <CustomizeHeader>虛實整合<br/>移動式 AI 智能教練</CustomizeHeader>
                            AI 智能教練提供專屬訓練指導與即時動作矯正，不管在哪裡，都能讓運動更有效率、更有趣！
                        </ScrollAnimation>
                    </CustomizeItem>
                    <CustomizeItem md={5} sm={24} xs={24}>
                        <ScrollAnimation animateIn='fadeIn' animateOnce delay={400}>
                            <img src={img_customize_03} alt='img_customize_03' />
                            <CustomizeHeader>動作開發<br/>主管變身虛擬教練</CustomizeHeader>
                            為您的企業開發獨一無二、專屬運動健身動作，打造專屬的健康訓練體驗。
                        </ScrollAnimation>
                    </CustomizeItem>
                    <CustomizeItem md={5} sm={24} xs={24}>
                        <ScrollAnimation animateIn='fadeIn' animateOnce delay={600}>
                            <img src={img_customize_04} alt='img_customize_04' />
                            <CustomizeHeader>工作坊<br/>與線下活動整合</CustomizeHeader>
                            與線下實體活動並行，讓運動更多元，進而打造充滿活力的職場文化！
                        </ScrollAnimation>
                    </CustomizeItem>
                </Row>
                <Row style={{ display: 'flex', justifyContent: 'center', marginTop: '60px' }}>
                    <ConsultButton />
                </Row>
                <Col md={24} sm={0} xs={0} style={{ position: 'absolute', bottom: '-260px', right: '60px' }}>
                    <img src={img_plan_pet_4} alt='img_plan_pet_4' style={{ width: '450px' }} />
                </Col>
            </div>
        </SolutionWrapper>
    );
};

export default Solution;
